export default {
  title: "Welcome",
  description:
    "EXPOcentre is a world-known Russian organiser of major trade shows and congresses in Russia, the CIS and Eastern Europe with close to 60 years of experience.",

  cards: {
    add: "Participate in interesting exhibitions",
    notify: "Receive notifications on exhibition deadlines",
    control: "Manage your participation in the exhibition",
    order: "Order passes and get published in the online catalogue"
  },

  videoTitle: "Learn more about Expocentre",

  howTo: {
    title: "How do I take part in the exhibition?",
    step1: "Add exhibitions of your interest",
    step2: "Leave an application for participation",
    step3: "Our manager will contact you and we will sign a contract"
  },

  contact: {
    title: "Any questions? Ask them to us!",
    callPhone: "Or call by phone:"
  }
};
